import { message } from 'antd';
import { config } from 'util/config';
import { httpClient } from "util/Api";
import * as globalFunction from 'util/GlobalFunction';

export function getSectionDataByDefault({ sectionName, parameter, sectionComponent, pageComponent, uie } = {}) {
  if (parameter !== undefined) {
    pageComponent.setState({ defaultFormData: { moduleId: parameter } });
    let componentDefaultValue = { ...sectionComponent.state.componentDefaultValue };
    componentDefaultValue[uie.source] = parameter;
    sectionComponent.setState({ searchParameter: { moduleId: parameter }, componentDefaultValue });
    setTimeout(() => {
      sectionComponent.getSectionDataByDefault();
    }, config.setTimeoutMilliSecond);
  } else {
    message.error('Client has no module linked.');
  }
}

export function addBySection({ sectionName, parameter, sectionComponent, pageComponent, uie } = {}) {
  if (!pageComponent.state.submitting) {
    pageComponent.setState({ submitting: true });
    let form = {};
    form.moduleId = pageComponent.state.defaultFormData.moduleId;
    httpClient
      .post('/Admin/ClientJobTemplate', form)
      .then(({ data }) => {
        if (data.result) {
          pageComponent.setState({ submitting: false });
          pageComponent.props.history.push('/admin/job-template-detail/' + data.data.ClientJobTemplateId);
        } else {
          pageComponent.setState({ submitting: false });
          globalFunction.handleResultError(data, pageComponent);
        }
      }).catch(function (error) {
        pageComponent.setState({ submitting: false });
        globalFunction.handleError(error, pageComponent);
      });
  }
}
